var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8512 21.3529L14.6247 19.0768L18.3981 21.3828L17.4098 17.0703L20.734 14.1953L16.3617 13.806L14.6247 9.73307L12.8877 13.776L8.5153 14.1654L11.8395 17.0703L10.8512 21.3529ZM7.22754 26.3542L9.17415 17.9388L2.64551 12.2786L11.2705 11.5299L14.6247 3.59375L17.9788 11.5299L26.6038 12.2786L20.0752 17.9388L22.0218 26.3542L14.6247 21.8919L7.22754 26.3542Z",
    fill: "#FEAD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/emptyStar.be5b409018d2c9d260674c9ae40f7154.svg";
export { ForwardRef as ReactComponent };